(function() {
   // Repairability Score
   var theScore = App.repairabilityScore;
   var teardownConclusion;

   // Color variables
   var colors = [
      '#E01410',
      '#EB2C0A',
      '#EF5803',
      '#F38800',
      '#F4B700',
      '#F0DC02',
      '#DAE60D',
      '#9ADA0D',
      '#5DD113',
      '#2DCF1C',
      '#0BCD20',
   ];

   // Angle for meter hand
   var rotationStart = 135;
   var rotationEnd = 405;
   var rotationTargetPosition;

   function setMeterPosition(repairabilityScore) {
      var difference = (rotationEnd - rotationStart) / 10;
      rotationTargetPosition = difference * repairabilityScore + rotationStart;
   }

   // Angle for color bar
   var colorBarStart = 227;
   var colorBarEnd = 454;
   var colorBarTargetPosition;

   function setColorBarPosition(repairabilityScore) {
      var difference = (colorBarEnd - colorBarStart) / 10;
      colorBarTargetPosition = difference * repairabilityScore + colorBarStart;
   }

   function showScoreNumber() {
      TweenMax.to('meter-counter', 0.75, {
         opacity: 1,
         scaleY: 1,
         textShadow: '0 0 30px ' + colors[theScore],
         ease: Elastic.easeOut,
      });
      TweenMax.set('meterProgress', {
         attr: { 'stroke-dashoffset': colorBarTargetPosition },
      });
      TweenMax.set('meterStroke', {
         attr: { 'stroke-width': 18 },
      });
   }

   function fillTheColorBar() {
      setColorBarPosition(theScore);
      TweenMax.fromTo(
         'meterProgress',
         2,
         { attr: { 'stroke-dashoffset': colorBarStart } },
         {
            attr: { 'stroke-dashoffset': colorBarTargetPosition },
            ease: Expo.easeIn,
            delay: 1,
            onComplete: showScoreNumber,
         }
      );
   }

   function rotateMeterHand() {
      setMeterPosition(theScore);
      TweenMax.fromTo(
         'meterBar',
         2,
         { rotation: rotationStart },
         {
            rotation: rotationTargetPosition,
            ease: Expo.easeIn,
            delay: 1,
            onComplete: vibrateMeterHand,
         }
      );
   }

   function vibrateMeterHand() {
      if (Browser.name !== 'ie') {
         TweenMax.fromTo(
            'meterBar',
            1 / (theScore + 5),
            { rotation: rotationTargetPosition - theScore / 3 },
            { rotation: rotationTargetPosition + theScore / 6, repeat: -1, yoyo: true }
         );
      }
   }

   var meterHandAnimated = false;
   function animateRepairMeter() {
      rotateMeterHand();
      fillTheColorBar();

      var colorBar = $('meterStroke');
      if (Browser.name !== 'ie') {
         TweenMax.to(colorBar, 2, { stroke: colors[theScore], ease: Power1.easeOut, delay: 2 });
      } else {
         TweenMax.set(colorBar, { stroke: colors[theScore] });
      }

      TweenMax.set('meter-counter', { opacity: 0, scaleY: 0 });
      meterHandAnimated = true;
   }

   function checkRepairMeterFocus() {
      // Make sure we only animate it once.
      if (!meterHandAnimated) {
         var viewportHeight = window.getSize().y;
         var conclusionLocation = teardownConclusion.getPosition().y;
         var conclusionHeight = 250; // Approximate height of the gauge.
         if (getScroll().y > conclusionLocation - (viewportHeight - conclusionHeight)) {
            animateRepairMeter();
         }
      }
   }

   onDomReady(function() {
      if ((teardownConclusion = $('teardownConclusion'))) {
         checkRepairMeterFocus();
         window.addEvent('scroll:throttle(100):pause(100)', checkRepairMeterFocus);
      }
   });
})();
